import script from "./ColorPick.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorPick.vue?vue&type=script&lang=ts&setup=true"

import "./ColorPick.vue?vue&type=style&index=0&id=c12329be&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c12329be"]])

export default __exports__